export * from '@/interfaces/sender';
export * from '@/interfaces/contract';
export * from '@/interfaces/service';
export * from '@/interfaces/proxy_error';
export * from '@/interfaces/proxy_user_ban';
export * from '@/interfaces/template';
export * from '@/interfaces/user_profile';
export * from '@/interfaces/priority';
export * from '@/interfaces/utilities';
export * from '@/interfaces/mno';
export * from '@/interfaces/tag';
export * from '@/interfaces/service_ban_policy';

export interface IMessage {
  message: string;
  template_id?: number;
  service_id?: number;
  sender_id?: number;
  template?: string;
}

export interface IMessageParseResult {
  correct: boolean;
  keys: object | null;
}

export interface ISelectValue {
  text: string;
  value: any;
  disabled?: boolean;
}
